import { apiClient } from './apiClient';

export interface DashboardData {
  visitors: number;
  leads: number;
  closed_clients: number;
  revenue: string;
  conversion_rate: number;
  revenue_per_visitor: string;
  daily_data: { date: string; visitors: number; leads: number }[];
  revenue_by_source: { source: string; revenue: string }[];
}

export interface OpportunityFunnelBandCounts {
  generated: number;
  contacted: number;
  replied: number;
  won: number;
}

export interface OpportunityFunnelResponse {
  window_days: number;
  bands: Record<string, OpportunityFunnelBandCounts>;
}

export interface OpportunitySignalLift {
  present: number;
  absent: number;
  replied_present: number;
  replied_absent: number;
  won_present: number;
  won_absent: number;
  lift: { reply: number | null; win: number | null };
}

export interface ScoringPerformanceResponse {
  window_days: number;
  by_band: Record<string, OpportunityFunnelBandCounts>;
  by_signal: Record<string, OpportunitySignalLift>;
  response_times: {
    time_to_contact: { p50: number | null; p90: number | null; count: number };
    time_to_reply: { p50: number | null; p90: number | null; count: number };
  };
}

export const analyticsService = {
  async getDashboard(params?: { nocache?: boolean }): Promise<DashboardData> {
    const query = params?.nocache ? { nocache: '1' } : undefined;
    return apiClient.get('/analytics/dashboard/', query);
  },

  async getOpportunityFunnel(params?: { window?: number }): Promise<OpportunityFunnelResponse> {
    const windowDays = params?.window ?? 30;
    return apiClient.get('/analytics/opportunity-funnel/', { window: `${windowDays}d` });
  },

  async getScoringPerformance(params?: { window?: number }): Promise<ScoringPerformanceResponse> {
    const windowDays = params?.window ?? 30;
    return apiClient.get('/analytics/scoring-performance/', { window: `${windowDays}d` });
  },
};
